import moment from "moment";
import { Artist } from "./Artist";
import { Host } from "./Host";
import { Location } from "./Location";
import { Photo } from "./Photo";

export class Concert {
  constructor(data) {
    var self = this;
    self.type = "Concert";

    self.rootvm = data.rootvm;

    self.concert_date = ko.observable(new moment(data.confirmed_event_date));
    self.concert_time = ko.observable(data.concert_time || "12:12");
    self._confirmed_event_date = ko.observable(data.confirmed_event_date);
    self.concert_uuid = ko.observable(data.event_uuid);
    self.concert_type = ko.observable(data.event_type);
    self.concert_privacy = ko.observable(data.event_privacy);
    self.concert_title = ko.observable(data.event_title);
    self.concert_external_link = ko.observable(data.external_web_link);

    self.concert_time = ko.observable(data.confirmed_event_time);

    self.concert_slug = ko.observable(data.concert_slug);

    self.artist = ko.observable(new Artist(data.artist || {}));
    self.host = ko.observable(new Host(data.host || {}));
    self.concert_location = ko.observable();

    // This is all extra info
    //this is a location
    self.concert_address = ko.observable(new Location({}));
    self.concert_message = ko.observable();
    self.concert_good_to_know = ko.observable();

    self.update_extra_info = function (data) {
      self.concert_address(new Location(data.concert_location_address || {}));
      self.concert_good_to_know(data.concert_good_to_know);
      self.concert_message(data.concert_message);
    };

    // for search
    self.distance_in_m = ko.observable(data.distance_in_m);
    self.distance_in_km = ko.computed(function () {
      if (self.distance_in_m() != undefined && self.distance_in_m() != null) {
        return Math.round(self.distance_in_m() / 1000) + " km";
      }
    });

    self.host_pic = ko.computed(function () {
      if (self.host().host_uuid() && self.host().profile_photo()) {
        return self.host().profile_photo().icon_path_url();
      } else {
        return "/images/icon/category-sofaconcert.png";
      }
    });

    self.concert_pic = ko.computed(function () {
      return "/images/icon/category-" + self.concert_type() + ".png";
    });

    self.no_call_to_action = ko.computed(function () {
      return self.concert_type() == "external" && !self.concert_external_link();
    });

    self.artist_pic = ko.computed(function () {
      if (self.artist().artist_uuid() && self.artist().profile_photo()) {
        return self.artist().profile_photo().icon_path_url();
      }
    });

    // Return the mdi icon for the state
    self.privacy_icon = ko.computed(function () {
      if (self.concert_privacy() == "public") {
        return "mdi-account-multiple";
      } else if (self.concert_privacy() == "invite") {
        return "mdi-account-multiple-plus";
      } else {
        return "mdi-account-key";
      }
    });

    // Return the mdi icon for the state
    self.call_to_action_icon = ko.computed(function () {
      if (
        self.concert_privacy() == "public" &&
        self.concert_type() == "external"
      ) {
        return "mdi-open-in-new";
      } else if (
        /*if(self.concert_privacy() == 'public' && self.concert_type() != 'external'){
                return 'mdi-account-multiple';
            }*/
        self.concert_privacy() == "invite" ||
        self.concert_privacy() == "public"
      ) {
        return "mdi-account-multiple-plus";
      } else {
        return "mdi-account-key";
      }
    });

    self.tile_action_i18n_key = ko.computed(function () {
      if (
        self.concert_privacy() == "public" &&
        self.concert_type() == "external"
      ) {
        return "search.tile_action.concert.public";
      } else if (self.concert_privacy() == "closed") {
        return "search.tile_action.concert.closed";
      } else {
        return "search.tile_action.concert.invite";
      }
    });

    if (data.location) {
      self.concert_location(new Location(data.location));
    }

    self.concert_name = ko.computed(function () {
      // Todo we'll need translation here
      if (self.artist().artist_uuid() && i18nextko.i18n.translator) {
        var category_trans;
        // First translate the cateogry
        if (self.concert_title()) {
          category_trans = self.concert_title();
        } else {
          category_trans = i18nextko.i18n.translator.translate(
            "general.category." + self.concert_type() + "._"
          );
        }

        var concert_trans = i18nextko.i18n.translator.translate(
          "profile.concert.title",
          {
            artist: self.artist().artist_name(),
            category: category_trans,
          }
        );

        return concert_trans;
      }
    });

    self.concert_location_name = ko.computed(function () {
      // Todo we'll need translation here
      if (self.host().host_name()) {
        return self.host().host_name();
      } else if (self.concert_title()) {
        return self.concert_title();
      } else {
        return "general.category." + self.concert_type() + "._";
      }
    });

    self.concert_link = ko.computed(function () {
      // Todo we'll need translation here
      if (self.host().username()) {
        return (
          "/" +
          self.rootvm.selected_language() +
          "/hosts/" +
          self.host().username()
        );
      } else if (self.concert_external_link()) {
        return self.concert_external_link();
      } else if (self.concert_type() == "external") {
        return null;
      } else {
        switch (self.concert_type()) {
          case "wedding":
            return "/de/hochzeit";
          case "special_occasion":
            return "/de/band-buchen-wohnzimmerkonzert-geburtstagsgeschenk";
          case "birthday":
            return "/de/geburtstagsfeier";
          case "corporate_event":
            return "/de/firmenfeier";
          default:
            return "/de/band-buchen-wohnzimmerkonzert-geburtstagsgeschenk";
        }
      }
    });

    self.concert_link_css = ko.computed(function () {
      // Todo we'll need translation here
      if (self.host().username()) {
        return "mdi-home";
      } else {
        /*else if(self.concert_external_link())  {
                return 'mdi-link-variant';
            }*/
        return "mdi-music-note";
      }
    });

    self.pretty_location = ko.computed(function () {
      if (self.concert_location()) {
        return self.concert_location().location_name();
      }
    });

    // make sure we don't actually pass the time back
    // from the server if we're not allowed to see it
    self.show_concert_time = ko.computed(function () {
      return false;
    });

    // make sure we don't actually pass the time back
    // from the server if we're not allowed to see it
    self.show_concert_address = ko.computed(function () {
      return false;
    });
  }
}

export class ConcertGuestListSpot {
  constructor(data) {
    var self = this;
    self.type = "ConcertGuestListSpot";

    self.rootvm = data.rootvm;

    self.concert_uuid = data.event_uuid;
    self.person_uuid = data.person_uuid;

    self.display_name = ko.observable(data.display_name);
    self.guest_list_status = ko.observable(data.guest_list_status);
    self.profile_photo = ko.observable();
    if (data.profile_photo) {
      self.profile_photo(new Photo(data.profile_photo));
    }

    self.message = ko.observable(data.message);

    self.inserted = ko.observable(new moment(data.inserted));

    self.is_approved = ko.pureComputed(function () {
      return self.guest_list_status() == "approved";
    });

    self.is_requested = ko.pureComputed(function () {
      return self.guest_list_status() == "requested";
    });
    self.is_denied = ko.pureComputed(function () {
      return self.guest_list_status() == "denied";
    });

    self.messages_unread = ko.observable(false || data.messages_unread);

    self.messages = ko.observableArray([]);
  }
}

export class ConcertGuestListMessage {
  constructor(data) {
    var self = this;
    self.type = "ConcertGuestListMessage";

    self.rootvm = data.rootvm;

    self.message = ko.observable(data.message);
    self.inserted = ko.observable(new moment(data.inserted));
    self.message_read = ko.observable(data.message_read);
    self.sender_icon_path = ko.observable(data.sender_icon_path);
    self.sender_display_name = ko.observable(data.sender_display_name);
  }
}

export class CharityConcert {
  constructor(data) {
    var self = this;
    self.type = "CharityConcert";
    self.rootvm = data.rootvm;

    self.location_obj = ko.observable(new Location(data.location));
    self.concert_date = ko.observable(data.concert_date);

    self.concert_date_moment = ko.pureComputed(function () {
      if (self.concert_date()) {
        return new moment(self.concert_date());
      }
    });
  }
}
